export default class PvApiServerErrorException extends Error {
    constructor() {
        super();
        this.name = '5**';
        this.message = 'Ошибка сервера';
    }
}